export default "/_next/static/assets/DunbarTall-Light_67a854eb99543a9c2052b84db9284398.woff2";